import curry from 'lodash/curry'
import {
  fork,
  take,
} from 'redux-saga/effects'

const createFilteredTakeEvery = curry((predicate, pattern, saga, ...args) => fork(function* () {
  while (true) {
    const action = yield take(pattern)
    const shouldRun = predicate(action)
    if (shouldRun) yield fork(saga, ...args.concat(action))
  }
}))

const createTakeEveryName = name => createFilteredTakeEvery(action => action.name === name)

function* logSagas() {
  // while(true){
  //   const { type } = yield take('*')
  //   console.log(type)
  // }
}


export {
  createTakeEveryName,
  createFilteredTakeEvery,
  logSagas,
}
